@for (notification of notifications; track notification) {
  <div class="well">{{notification.text}}</div>
}
